<script>
    import { langTextStore } from "../store/langtexts.js";
    import { getContext } from "svelte";
    const { close } = getContext("modal");

    export let newVersion;
    export let oldVersion;
    export let doUpdate;
    //var diffs =
    //    "<table><thead><tr><th>var</th><th>old</th><th>new</th></tr></thead><tbody>";

    var diffs = "";
    for (var theVar in newVersion.variables) {
        var actualVar = newVersion.variables[theVar];
        var oldVar =
            oldVersion.variables.find(
                (v) => v.varNameKey == actualVar.varNameKey
            ) || {};

        if (actualVar.formula + "" != oldVar.formula + "") {
            diffs +=
                "<div class='col-12'><strong>" +
                actualVar.varNameKey +
                "</strong></div><div class='col-1 text-gray-5 font-weight-bold'>v" +
                oldVersion.calculatorVersionNumber +
                "</div><div class='col-11 text-gray-5 '>" +
                oldVar.formula +
                "</div><div class='col-1 mb-3 text-gray-5 font-weight-bold'>v" +
                newVersion.calculatorVersionNumber +
                "</div><div class='col-11 mb-3 text-gray-5'>" +
                actualVar.formula +
                "</div>";
        }
    }
    //diffs += "</tbody></table>";
</script>

<div class="modal-header-xx">
    <h3 class="text-gray-6" id="exampleModalLabel">
        {$langTextStore.getText("general-major-update-title")}
    </h3>
</div>
<div class="modal-body">
    <p class="text-small ">
        {$langTextStore.getText("general-major-update-explanation")}
    </p>
    <p class="text-small font-weight-bold">
        Old version: {oldVersion.calculatorVersionNumber}<br />
        New version: {newVersion.calculatorVersionNumber}
    </p>
    <hr class="mt-4 mb-4" />
    <div class="row g-0 text-small ">
        {@html diffs}
    </div>
</div>

<div class="modal-footer-xx text-center mb-5 ">
    <hr class="mt-4 mb-4" />
    <button
        class="btn btn-primary width-unset"
        on:click={() => {
            doUpdate();
            close();
        }}>{$langTextStore.getText("general-major-update-update-now")}</button
    >
    <button class="btn btn-gray width-unset ms-2 me-2" on:click={close}
        >{$langTextStore.getText("general-major-update-ignore-for-now")}</button
    >
</div>
